import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../context/AuthContext'
import { useToast } from './Toast'

// "Read Their Work" button — The Margins' version of follow
// Shows on writer profile pages
export default function ReadTheirWork({ writerId, writerName }) {
  const { user } = useAuth()
  const toast = useToast()
  const [connected, setConnected] = useState(false)
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!writerId) return
    // Get total reader count
    supabase.from('connections').select('id', { count: 'exact' })
      .eq('writer_id', writerId)
      .then(({ count: c }) => setCount(c || 0))

    // Check if current user is connected
    if (user) {
      supabase.from('connections')
        .select('id').eq('follower_id', user.id).eq('writer_id', writerId)
        .single()
        .then(({ data }) => setConnected(!!data))
    }
  }, [writerId, user])

  async function toggle() {
    if (!user) { toast('Sign in to add writers to your margins.', 'error'); return }
    if (user.id === writerId) { toast("You can't add yourself.", 'error'); return }
    setLoading(true)
    if (connected) {
      await supabase.from('connections')
        .delete().eq('follower_id', user.id).eq('writer_id', writerId)
      setConnected(false)
      setCount(n => Math.max(0, n - 1))
      toast('Removed from your margins.', 'success')
    } else {
      await supabase.from('connections')
        .insert({ follower_id: user.id, writer_id: writerId })
      setConnected(true)
      setCount(n => n + 1)
      toast(`${writerName} is now in your margins.`, 'success')
    }
    setLoading(false)
  }

  return (
    <button
      onClick={toggle}
      disabled={loading}
      className={`rtw-btn ${connected ? 'rtw-btn-active' : ''}`}
    >
      {connected ? '◈ In My Margins' : '◇ In My Margins'}
      {count > 0 && <span className="rtw-count">{count}</span>}
    </button>
  )
}
